var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacebookBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1078 4.15556H4.9792C4.44703 4.15556 4.01709 4.57286 4.01709 5.08938V26.5672C4.01709 27.0837 4.44703 27.501 4.9792 27.501H27.1078C27.64 27.501 28.0699 27.0837 28.0699 26.5672V5.08938C28.0699 4.57286 27.64 4.15556 27.1078 4.15556ZM24.3297 10.9695H22.4085C20.9022 10.9695 20.6105 11.664 20.6105 12.6854V14.9353H24.2064L23.7374 18.4575H20.6105V27.501H16.8613V18.4605H13.7254V14.9353H16.8613V12.3381C16.8613 9.32365 18.7585 7.68072 21.5306 7.68072C22.8595 7.68072 23.999 7.77702 24.3327 7.82079V10.9695H24.3297Z",
    fill: "#004876"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebookBlue);
export default __webpack_public_path__ + "static/media/icon-facebook-blue.386e536ecbc362e11bd873d4ce2f2051.svg";
export { ForwardRef as ReactComponent };